// extracted by mini-css-extract-plugin
export default {"root":"UserSelect_root__VOqv1","container":"UserSelect_container__Ojbtr"};